module.exports = __webpack_public_path__ + "img/at0.42232335.png";